<!-- 日期时间控件 -->
<template>
  <el-date-picker
    v-model="pickValue"
    :type="type?'datetimerange':'daterange'"
    align="right"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :value-format="type?'YYYY-MM-DD HH:mm:ss':'YYYY-MM-DD'"
    :picker-options="pickerOptions"
    @change="changeTime"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: "date-picker",
  props: ['startDate', 'endDate','unDisabled','type','disabledType'],
  watch:{
    endDate:function(n){
      this.pickValue= [this.startDate,this.endDate];
    }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }],
      },
      pickValue: [],
    }
  },
  methods: {
    changeTime(dateArr) {
      this.$emit('change',dateArr);
    },
    clearTime(){
      this.pickValue= [];
    }
  },
  mounted() {
    if(this.startDate&&this.endDate){
      this.pickValue = [this.startDate,this.endDate];
    }
    if(this.unDisabled!=''||this.unDisabled){
      this.pickerOptions.disabledDate = (date)=>{
        if(this.disabledType){
          return (date.getTime()) > new Date().getTime();
        }else{
          return (date.getTime() + 3600 * 1000 * 24) <= new Date().getTime();
        }
      }
    }
  }
}
</script>


<style lang="less" scoped>

</style>
